var exports = {
  "an": "ErrorFallback.module__errorFallbackContainer___NktxdE",
  "MU": "ErrorFallback.module__errorFallbackIcon___NktxdE",
  "S6": "ErrorFallback.module__errorFallbackContent___NktxdE",
  "jQ": "ErrorFallback.module__errorFallbackTitle___NktxdE",
  "pF": "ErrorFallback.module__errorFallbackDescription___NktxdE",
  "sM": "ErrorFallback.module__errorFallbackActions___NktxdE",
};

module.exports = exports;
